var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("404了，你自己想想办法，我不想提供方法带你出去，等我想带你出去再写")])}
var staticRenderFns = []

export { render, staticRenderFns }